import React, {useCallback, useState} from 'react';
import ExecutableModal from "../../../executableModal/ExecutableModal";
import {ExecutableModalProps} from "../../../../models/Modals";
import {Button, Form, Input} from "antd";
import {CreateFleetExpensesTransportParameters} from "../../../../models/FleetExpenses/FleetExpensesTransport";
import validations from "./validations";
import {formItemFactory} from "../../../formItems/FormItemFactory";
import FleetExpensesStore from "../../../../stores/FleetExpensesStore";
import {addMessage, callMessages} from "../../../../helpers/flashMessage";

type CreateTransportModalProps = ExecutableModalProps<{
  store: typeof FleetExpensesStore;
}>;

export type CreateFleetExpensesTransportFormValues = CreateFleetExpensesTransportParameters;

const CreateFleetExpensesTransportItem = formItemFactory<CreateFleetExpensesTransportFormValues>(validations);

const CreateFleetExpensesTransportModal = ({ handler, store }: CreateTransportModalProps) => {
  const [form] = Form.useForm<CreateFleetExpensesTransportFormValues>();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const onShow = useCallback(() => {
    form.setFieldsValue({
      tc_number: '',
    });
  }, [form]);

  const handleCreate = useCallback(async () => {
    try {
      const values: CreateFleetExpensesTransportFormValues = await form.validateFields();
      setIsLoading(true);

      try {
        await store.createTransport(
          {...values}
        );
      } catch {
        addMessage('Transport could not be created due to internal error', 'error');
      }
      callMessages();

      handler.executeClose();
    } catch {
      // validation failed — do nothing, Ant Design shows inline errors
    } finally {
      setIsLoading(false);
    }
  }, [form, store]);

  const ModalFooter = () => (
    <>
      <Button key="cancel" onClick={handler.executeClose}>
        Cancel
      </Button>
      <Button
        key="create"
        type="primary"
        loading={isLoading}
        onClick={handleCreate}
      >
        Create TC
      </Button>
    </>
  );

  return (
    <ExecutableModal
      handler={handler}
      title="Create TC"
      footer={<ModalFooter />}
      onShow={onShow}
    >
      <Form form={form} layout="vertical">
        <CreateFleetExpensesTransportItem name={'tc_number'} label={'TC Number'}>
          <Input type={'text'} placeholder={'Enter TC Number'} />
        </CreateFleetExpensesTransportItem>
      </Form>
    </ExecutableModal>
  );
};

export default CreateFleetExpensesTransportModal;